import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
  Grid
} from "@mui/material";
import StepLayout from "../../components/StepLayout/StepLayout";
import { useTunnelDispatch, useTunnelState } from "../../context/TunnelContext";
import { GUMS } from "../../utils/mockData";

export default function GumSelection() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const { currentShoe } = useTunnelState();

  useEffect(() => {
    if (!currentShoe.size) {
      navigate("/nouvelle-demande/marque", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function selectGum(gumId) {
    dispatch({ type: "SET_GUM", gum: gumId });
    navigate("/nouvelle-demande/service");
  }

  return (
    <StepLayout title="Choix de la gomme">
      <Grid container spacing={3} sx={{ minWidth: 640 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        {/* <Stack spacing={3} sx={{ maxWidth: 640 }}> */}
        {GUMS.map((gum) => (
          <Grid item size={6}  key={gum.id}>
            <Card key={gum.id} variant="outlined" style={{ height: "100%" }}>
              <CardContent>
                <Typography variant="h6">{gum.label}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {gum.description}
                </Typography>
              </CardContent>
              <CardActions style={{ marginTop: "auto" }}>
                <Button variant="contained" onClick={() => selectGum(gum.id)}>
                  Choisir
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
        {/* </Stack> */}
      </Grid>
    </StepLayout>
  );
}
